export default function UIDivider({ className }) {
    return (
        <div className={`lg:border-r-2 flex border-b-2 w-full my-[16px] lg:w-[1px] lg:mx-0  border-green-200 ${className}`}>
        </div>
    )
}
